import { ERentioFormField } from "@rentiohq/shared-frontend/dist/components/components/Form";
import { IUiSchema } from "@rentiohq/shared-frontend/dist/forms/forms.types";
import { getValue } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { IPartialRootState } from "@rentiohq/shared-frontend/dist/redux/types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import utils from "@rentiohq/web-shared/dist/utils";
import { JSONSchema6 } from "json-schema";
import { EField, IExtraData } from "./schema.createDocumentPackage.types";
import { getNavigationTitle } from "./schema.createDocumentPackage.utils";

export const getSchema =
  (initialValues: { [key: string]: unknown }, extraData: IExtraData) =>
  (defaultValues: { [key: string]: unknown }): JSONSchema6 => {
    return {
      required: [],
      properties: {
        [EField.Header + "1"]: {
          default: undefined,
        },
        [EField.Property]: {
          default: getValue(EField.Property, initialValues, defaultValues),
          // @ts-ignore
          showIf: (_: any) => !extraData.sendToTenant,
        },
      },
    };
  };

export const uiSchema = (_extraData: IExtraData): IUiSchema<EField> => {
  return {
    "rentio:title": utils.i18n.t("document_package.form.property.heading"),
    "rentio:navigationTitle": getNavigationTitle(),
    [EField.Header + "1"]: {
      "ui:field": ERentioFormField.SectionHeader,
      title: utils.i18n.t("document_package.form.property.heading"),
    },
    [EField.Property]: {
      "ui:field": ERentioFormField.PropertySelectInline,
      title: utils.i18n.t("document_package.form.property.label"),
      optional: true,
      selectPropertyFromListCtaTitle: undefined,
      hideOnSummaryIfEmpty: true,
      valueSelector: (state: IPartialRootState, propertyId: number) => {
        if (propertyId) {
          const property = state.PROPERTY_V2.detail[propertyId]?.entity;
          if (property) {
            return property.name;
          }

          return getLocalizedText("summary.view.property");
        }
        return getLocalizedText("property.no.summary");
      },
    },
  };
};
